import React, { useEffect, useState } from 'react'

import Loader from '@Pure/Loader'

import request from '@function/ajax/request'

const { moment } = window;

const header =
[
	{ name: 'number', label: 'Numéro' },
	{ name: 'date', label: 'Date' },
	{ name: 'total_price', label: 'Montant avoir' },
	{ name: '_link' },
];

export default function CreditNotesListInfos ({ bill, ...props })
{
	const [credit_notes, setCreditNotes] = useState();
	const [loading, setLoading] = useState(!credit_notes);

	useEffect(function ()
	{
		if (!bill) return;

		const controller = new AbortController();

		(async function ()
		{
			setLoading(true);


			try
			{
				var { credit_notes } = await request(
					'/credit-notes/get-bill-credit-notes-list'
				)
				.config({ controller, keyword: 'action' })
				.post({ bill_id: bill });
			}
			catch (update)
			{
				if (controller?.signal?.aborted) return;
			}

			setLoading(false);
			setCreditNotes(credit_notes || []);
		})();

		return () => { controller?.abort?.(); };
	},
	[bill]);

	const credit_notes_list = (credit_notes || []).map(function (credit_note)
	{
		return (
			<div key={ credit_note.id }
				className="c-billing-list__row">
				<div className="c-billing-list__cell BL-number">
					{ credit_note.number }
				</div>
				<div className="c-billing-list__cell BL-date">
					{ moment(credit_note.date).format('DD/MM/YYYY') }
				</div>
				<div className="c-billing-list__cell BL-total_price">
					-{ credit_note.total_price }&nbsp;€
				</div>
				<div className="c-billing-list__cell BL-_link">
					<a href={ '/gestion-des-avoirs/?id=' + credit_note.id }
						target="_blank" rel="noreferrer">
						Voir
					</a>
				</div>
			</div>
		);
	});

	const loader = loading === true ?
	(
		<Loader className="c-loader" bemit={ ['primary', 'bg-white'] } />
	)
	: undefined;

	const header_cells = header.map(function ({ name, label })
	{
		return (
			<div className={ 'c-billing-list__cell BL-' + name } key={ name }>
				{ label }
			</div>
		);
	});

	return (
		<div className="c-billing-list">

			<div className="c-billing-list__title">
				Avoirs sur cette facture
			</div>

			{
				credit_notes_list?.length > 0 === false && !loader ?
				(
					<p className="c-billing-list__nothing">
						Aucun avoir créé pour l'instant.
					</p>
				)
				:
				(
					<div className="c-billing-list__table">
						<div className="c-billing-list__row is-head-row">
							{ header_cells }
						</div>

						{ credit_notes_list }
					</div>
				)
			}

			{ loader }

		</div>
	);
}